<template>

  <!-- Titled Text Element -->
  <page-block
    v-if="hasContent"
    :no-body="noBody"
    :bg-color="value.bgColor"
    class="titled-text-element"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    :overlay-class="overlayClasses"
    wrapper-class="titled-text-element__wrapper">

    <!-- Title -->
    <h2
      v-if="hasTitle"
      class="text-bold"
      v-html="$u.nToBr(value.title.ru)"/>

    <!-- File -->
    <file-background
      :style="fileStyle"
      :value="value.file"
      :video-ratio="16/12.5"
      v-if="!noFile && value.file"
      class="titled-text-element__file"/>

    <!-- Body -->
    <div
      v-if="hasBody"
      v-html="value.body.ru"
      class="titled-text-element__body fr-view"/>

    <!-- Buttons -->
    <page-block-buttons
      :value="value.buttons"
      class="titled-text-element__buttons"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import FileBackground from '@src/components/file/file-background';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'titled-text-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
      overlayClass: {
        type: String,
        default: '',
      },
      noBody: {
        type: Boolean,
        default: false,
      },
      noFile: {
        type: Boolean,
        default: false,
      },
      noBottom: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PageBlock,
      FileBackground,
      PageBlockButtons,
    },
    computed: {
      overlayClasses() {

        const classes = [
          'clearfix',
        ];

        if (this.noBottom)
          classes.push('q-pb-none');

        if (this.overlayClass)
          classes.push(this.overlayClass);

        if (this.value.paddingClass)
          classes.push(this.value.paddingClass);

        return classes.join(' ');
      },
      fileStyle() {

        const style = {};
        const margin = '2.5rem';
        const {textAlign} = this.value;

        if (textAlign !== 'center')
          style.float = textAlign || 'left';

        if (textAlign === 'right')
          style.marginLeft = margin;

        else if (textAlign !== 'center')
          style.marginRight = margin;

        return style;
      },
    },
  };

</script>

<style lang="scss">

  .titled-text-element {
    color: inherit;

    &__file {
      max-width: 24%;
      overflow: hidden;
      border-radius: 8px;
      display: inline-block;

      @media (max-width: $breakpoint-md) {
        max-width: 26%;
      }

      @media (max-width: $breakpoint-sm) {
        max-width: 31%;
      }

      @media (max-width: 946px) {
        max-width: 260px;
      }

      @media (max-width: 640px) {
        min-width: 100%;
        max-width: unset;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }

    &__file.video {
      width: 100%;
    }

    &__wrapper > * {
      margin-bottom: 0;
    }

    &__wrapper > *:not(:first-child) {
      margin-top: $ibs-y;
    }

    &:nth-child(even) {
      background-color: rgba(150, 150, 150, .08);
    }
  }

</style>
